import { ExportOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import './style.less';

const AuthorCommiteeName = ({ committeeShortName, commiteeName, className = '' }) => {
  return (
    <Tooltip
      trigger={['hover', 'focus']}
      title={commiteeName}
      className={`${className} gx-ml-1`}
    >
      <Tag color="blue">{committeeShortName}</Tag>
    </Tooltip>
  );
};

function SearchLabel({ user, committeeTagClassName, isAuthorExist }) {
  const isAuthor = user.roles.includes('ROLE_AUTHOR');
  return (
    <div className="gx-d-flex gx-align-items-center gx-justify-content-between">
      <div className="gx-d-flex gx-align-items-center  gap-2">
        <Tooltip
          trigger={['hover', 'focus']}
          title={isAuthor ? 'Bu kullanıcı zaten bir yazar olarak kayıtlıdır.' : null}
        >
          {user?.firstName} {user?.lastName} ({user?.email})
        </Tooltip>
        {user?.memberships.map(({ committee }) => (
          <AuthorCommiteeName
            key={committee['@id']}
            className={committeeTagClassName}
            committeeShortName={committee.shortName}
            commiteeName={committee.name}
          />
        ))}
        {isAuthor && <Tag color="green">Yazar</Tag>}
      </div>
      <div>
        {isAuthorExist && (
          <Link
            className="gx-d-flex gx-justify-content-center gx-align-items-center"
            to={`/yazar-islemleri/yazar-duzenle/${user.id}`}
            target="_blank"
          >
            <ExportOutlined />
          </Link>
        )}
      </div>
    </div>
  );
}

export default SearchLabel;
